export default "__VITE_ASSET__IQTojHap__"